import { render, staticRenderFns } from "./KalenderMarketing.vue?vue&type=template&id=45129f98"
import script from "./KalenderMarketing.vue?vue&type=script&lang=js"
export * from "./KalenderMarketing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports